import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import RegisterKunjunganSvc from "@/services/RegisterKunjungan";

import store from "@/store";
import moment from "moment";

export interface IfcRegister {
  no: string;
  tgl: string;
  jam: string;
  unit: string;
  unit_nama?: string | null;
  unit_asal?: string | null;
  kl: string;
  dr: string;
  dout: string;
  hout: string;
  /**
   * ISO 8601 timestamp basis window 48-jam EMR readonly = jam keluar pasien
   * (`cm_reg__.dout` + `hout`), sama untuk ranap & ralan/IGD.
   * Null kalau dout belum diisi (pelayanan masih aktif / belum ditutup).
   */
  discharge_at?: string | null;
  cm: string;
  ke: string;
  umur: string;
  asal: string;
  cout: string;
  out2: string;
  wo: string;
  asr: string;
  asr_n: string;
  channel: string;
  ref_no: string;
  updt: string;
  t: string;
  is_bpjs: boolean;
  dokter: {
    id: number;
    nama: string;
    c_doc_id: string;
  };
  jurnal_ranap: [
    {
      tgl_in: string;
      jam_in: string;
      dr_id: string;
      unit: {
        id: string;
        name: string;
      };
      kelas: string;
      no_bed: string;
    }
  ];
}

interface IfcInfoBpjs {
  noSep: string;
  jnsPelayanan: string;
  tglSep: string;
  tglRujukan: string;
  diagnosa: string;
  potensiPRB: string;
}

@Module({ dynamic: true, namespaced: true, store, name: "register-kunjungan" })
class RegisterKunjungan extends VuexModule {
  register: IfcRegister = null;
  infoBpjs: IfcInfoBpjs = null;
  loading = false;

  get rujukanDaysRemaining() {
    const elapsDay = this.infoBpjs
      ? moment().diff(moment(this.infoBpjs.tglRujukan), "days")
      : null;

    return elapsDay !== null ? 90 - elapsDay : null;
  }

  get rujukanExpiredDate() {
    return this.infoBpjs
      ? moment(this.infoBpjs.tglRujukan)
          .add(90, "days")
          .format("YYYY-MM-DD")
      : null;
  }

  get isRujukanExpired() {
    return this.rujukanDaysRemaining !== null && this.rujukanDaysRemaining <= 0;
  }

  get isRujukanEndSoon() {
    return (
      this.rujukanDaysRemaining !== null && this.rujukanDaysRemaining <= 30
    );
  }

  @Mutation
  SET_REGISTER(register: IfcRegister) {
    this.register = register;

    if (register) {
      this.register?.jurnal_ranap
        .sort((a, b) => {
          return new Date(a.tgl_in).getTime() - new Date(b.tgl_in).getTime();
        })
        .values();
    }
  }

  @Mutation
  SET_INFOBPJS(info: IfcInfoBpjs) {
    this.infoBpjs = info;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation
  RESET_ALL() {
    this.register = null;
    this.infoBpjs = null;
    this.loading = false;
  }

  @Action({ rawError: true })
  async getRegister(noReg): Promise<any> {
    this.SET_LOADING(true);

    const register = await RegisterKunjunganSvc.get(noReg).finally(() => {
      this.context.commit("SET_LOADING", false);
    });

    this.SET_REGISTER(register.data);

    return register;
  }

  @Action({ rawError: true })
  async getInfoBpjs(noReg): Promise<any> {
    this.SET_LOADING(true);

    const info = await RegisterKunjunganSvc.getInfoBpjs(noReg).finally(() => {
      this.context.commit("SET_LOADING", false);
    });

    this.SET_INFOBPJS(info.data);

    return info.data;
  }

  @Action reset() {
    this.RESET_ALL();
  }
}

export default getModule(RegisterKunjungan);
